export const ON_FETCH_BEGIN = 'ON_FETCH_BEGIN';
export const ON_USERDATA_FETCH_SUCCESS = 'ON_USERDATA_FETCH_SUCCESS';
export const ON_USERDATA_FETCH_ERROR = 'ON_USERDATA_FETCH_ERROR';
export const SIGN_OUT = 'SIGN_OUT';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const ON_UPDATE_SUCCESS = 'ON_UPDATE_SUCCESS';
export const ON_UPDATE_ERROR = 'ON_UPDATE_ERROR';
export const ADD_ENTERPRISE_IDS = 'ADD_ENTERPRISE_IDS';
export const ADD_ENTERPRISE_EVENTS = 'ADD_ENTERPRISE_EVENTS';
